export const getCustomerBehavioursResp = [
  {
    behaviourType: "EFFICIENT_FLIGHT",
    name: "Efficient Flight",
    acronym: "EF",
    customerCode: "DA",
    createdDate: 1565647937062,
    description: "10% of flights beats flight plan",
    weight: 0.4,
    enabled: true,
    eventType: "FLIGHT",
  },
  {
    behaviourType: "REDUCED_ENGINE_TAXI_IN",
    name: "Reduced Engine Taxi In",
    acronym: "RETI",
    customerCode: "DA",
    createdDate: 1565647937062,
    description:
      "Ensure one engine burns less than 80% of the fuel burned by the other engine during taxi in.",
    weight: 0.3,
    enabled: true,
    eventType: "FLIGHT",
  },
  {
    behaviourType: "REDUCED_ENGINE_TAXI_OUT",
    name: "Reduced Engine Taxi Out",
    acronym: "RETO",
    customerCode: "DA",
    createdDate: 1565647937062,
    description:
      "Ensure one engine burns less than 80% of the fuel burned by the other engine during taxi out.",
    weight: 0.3,
    enabled: true,
    eventType: "FLIGHT",
  },
  {
    behaviourType: "DELAYED_FLAPS_APPROACH",
    name: "Delayed Flaps Approach",
    acronym: "DFA",
    customerCode: null,
    createdDate: null,
    description: "Delay deployment of flaps during the approach phase",
    weight: null,
    enabled: false,
    eventType: "FLIGHT",
  },
  {
    behaviourType: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
    name: "Optimal Discretionary Fuel Load",
    acronym: "ODFL",
    customerCode: null,
    createdDate: null,
    description:
      "Calculate and load only the fuel required to account for changes in zero fuel weight, within a 200kg buffer",
    weight: null,
    enabled: false,
    eventType: "FLIGHT",
  },
  {
    behaviourType: "PROMPT_DEPARTURE",
    name: "Prompt Departure",
    acronym: "PD",
    customerCode: null,
    createdDate: null,
    description:
      "Ensure Actual Time of Departure from the ship's berth is within 2.5 hours of last cargo hose disconnection",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "EFFICIENT_AUXILIARY_ENGINE_USE",
    name: "Efficient Auxiliary Engine Use",
    acronym: "EAEU",
    customerCode: null,
    createdDate: null,
    description:
      "Limit excess running hours to 1 hour or less by loading the minimum number of auxiliary engines to meet demand",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "OPTIMAL_TRIM",
    name: "Optimal Trim",
    acronym: "OT",
    customerCode: null,
    createdDate: null,
    description: "Trim the vessel according to the vessel's trim table",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "EFFICIENT_SFOC",
    name: "Efficient SFOC",
    acronym: "ESFOC",
    customerCode: null,
    createdDate: null,
    description: "While underway, meet the vessel’s expected ME SFOC value",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "EFFECTIVE_SHAFT_GENERATOR_USE",
    name: "Effective Shaft Generator Use ",
    acronym: "ESGU",
    customerCode: null,
    createdDate: null,
    description:
      "Whilst at sea, engage the shaft generator whenever above [x] ME RPM",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "EFFECTIVE_SPEED_MANAGEMENT",
    name: "Effective Speed Management",
    acronym: "ESM",
    customerCode: null,
    createdDate: null,
    description:
      "Ensure the vessel’s daily average STW does not exceed the instructed speed",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
  {
    behaviourType: "OPTIMAL_BOILER_LOAD",
    name: "Optimal Boiler Load",
    acronym: "OBL",
    customerCode: null,
    createdDate: null,
    description:
      "Limit boiler consumption in port to your ship-specific threshold (or to 0 MT/hr if at sea)",
    weight: null,
    enabled: false,
    eventType: "SHIPPING",
  },
];
